export default __webpack_public_path__ + "static/media/upload.4ec82192.svg";